import React from 'react';
import Grid from '@material-ui/core/Grid';
import Paper from '@material-ui/core/Paper';
import CardActionArea from '@material-ui/core/CardActionArea';
import CardMedia from '@material-ui/core/CardMedia';
import CardContent from '@material-ui/core/CardContent';
import Typography from '@material-ui/core/Typography';
import Card from '@material-ui/core/Card';
import { useHistory } from 'react-router';
import { makeStyles } from '@material-ui/core/styles';
import { VscSymbolMisc } from 'react-icons/all';
import getTheme from '../../../theme/theme';
import EcommerceMisc from '../../../assets/idna-ecommerce-misc.jpg';
import { eshopPages } from '../../../pages/EshopPage';

const useStyles = makeStyles((theme) => {
  return {
    root: {
      backgroundColor: theme.palette.secondary.main,
      height: '100%',
    },
  };
});

const ThematicPackageMisc = () => {
  const classes = useStyles();
  const history = useHistory();

  return (
    <>
      <div style={
        { display: 'flex',
          flexDirection: 'row',
          alignItems: 'center',
          marginTop: getTheme().spacing(4),
          marginBottom: getTheme().spacing(2) }
      }
      >
        <VscSymbolMisc style={ { marginRight: getTheme().spacing(2) } } size={ 24 } />
        <Typography style={ { marginRight: getTheme().spacing(2) } } variant='h6'>
          Miscellaneous
        </Typography>
      </div>
      <Grid container spacing={ 3 }>
        <Grid item xs={ 12 } md={ 6 }>
          <Card
            onClick={ () => {
              return history.push({
                pathname: '/eshop',
                search: `?page=${ eshopPages.DEPLOYED_THEMATIC_PACKAGES }`,
              });
            } }
            className={ classes.root }
            style={ { backgroundColor: '#5d5d5d' } }
          >
            <CardActionArea>
              <CardMedia
                component='img'
                alt=''
                image={ EcommerceMisc }
                title='Eshop deploy'
                height='300'
              />
              <CardContent>
                <Typography gutterBottom variant='h5' component='h2'>
                  <span style={ { color: '#eaeaea' } }>E-shop deployments</span>
                </Typography>
                <Typography variant='body2' color='textSecondary' component='p'>
                  <span style={ { color: '#ffffff' } }>
                    This section provides details about thematic packages deployments to the eshop.
                  </span>
                  <br />
                  <span style={ { color: '#ffffff' } }>
                    Deploy, publish or unpublish thematic packages as products.
                  </span>
                </Typography>
              </CardContent>
            </CardActionArea>
          </Card>
        </Grid>
        <Grid item xs={ 12 } md={ 6 }>
          <Paper />
        </Grid>
      </Grid>
    </>
  );
};

export default ThematicPackageMisc;
